import { render, staticRenderFns } from "./changePersonalInfo.vue?vue&type=template&id=48d97aae&scoped=true"
import script from "./changePersonalInfo.vue?vue&type=script&lang=js"
export * from "./changePersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./changePersonalInfo.vue?vue&type=style&index=0&id=48d97aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d97aae",
  null
  
)

export default component.exports